(function(){
  var root = document.querySelector('[data-stono-vsl-lander]');
  if (!root) return;
  var hero = root.querySelector('#top'),
      bar  = root.querySelector('#stickyCta'),
      prog = root.querySelector('#progress');

  if (!hero || !bar || !prog) return;

  if('IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      var past = !e[0].isIntersecting;
      bar.classList.toggle('show', past);
      root.classList.toggle('has-sticky', past);
    }, {threshold:0}).observe(hero);

    var reveal = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('in');
          reveal.unobserve(entry.target);
        }
      });
    }, {threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    root.querySelectorAll('.rise').forEach(function(el){ reveal.observe(el); });
  } else {
    root.querySelectorAll('.rise').forEach(function(el){ el.classList.add('in'); });
  }

  // Scroll progress — a long page needs a sense of distance travelled.
  var ticking = false;
  function draw(){
    var h = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if(!ticking){ window.requestAnimationFrame(draw); ticking = true; }
  }, {passive:true});
  draw();

  // One video at a time — coordinate native MP4 and optional YouTube players.
  var vids = root.querySelectorAll('video'),
      youtubeFrames = root.querySelectorAll('[data-stono-youtube-player]'),
      youtubePlayers = [];

  function pauseNativeExcept(active){
    vids.forEach(function(video){ if(video !== active){ video.pause(); } });
  }

  function pauseYouTubeExcept(active){
    youtubePlayers.forEach(function(player){
      if(player !== active && typeof player.pauseVideo === 'function'){
        player.pauseVideo();
      }
    });
  }

  vids.forEach(function(video){
    video.addEventListener('play', function(){
      pauseNativeExcept(video);
      pauseYouTubeExcept(null);
    });
  });

  function initializeYouTubePlayers(){
    if(!window.YT || typeof window.YT.Player !== 'function') return;

    youtubeFrames.forEach(function(frame){
      var player = new window.YT.Player(frame, {
        events: {
          onStateChange: function(event){
            if(event.data !== window.YT.PlayerState.PLAYING) return;
            pauseNativeExcept(null);
            pauseYouTubeExcept(event.target);
          }
        }
      });
      youtubePlayers.push(player);
    });
  }

  if(youtubeFrames.length){
    if(window.YT && typeof window.YT.Player === 'function'){
      initializeYouTubePlayers();
    } else {
      var previousYouTubeReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function(){
        if(typeof previousYouTubeReady === 'function') previousYouTubeReady();
        initializeYouTubePlayers();
      };

      if(!document.querySelector('script[data-stono-youtube-api]')){
        var youtubeApi = document.createElement('script');
        youtubeApi.src = 'https://www.youtube.com/iframe_api';
        youtubeApi.async = true;
        youtubeApi.setAttribute('data-stono-youtube-api', '');
        document.head.appendChild(youtubeApi);
      }
    }
  }
})();
